import React from "react";
import NumberFormat from "react-number-format";

/** 千分位金額。銷售方案統計與通路統計共用 */
export const Money = ({ value }) => (
  <NumberFormat value={value} displayType="text" thousandSeparator={true} />
);

/**
 * 本期/上期成對的數字欄。上期一律灰字 —— 兩欄並排時顏色是最快的區分方式。
 * null 顯示破折號而非空白:ADR 在沒進單時為 null,空白會與「均價 0」混淆。
 */
export const pairColumn = (title, key, prevKey, { money = false, width = 110 } = {}) => {
  const cell = (v) =>
    v === null || v === undefined ? (
      <span style={{ color: "#bfbfbf" }}>—</span>
    ) : money ? (
      <Money value={v} />
    ) : (
      v
    );
  const sorter = (k) => (a, b) => (a[k] ?? -Infinity) - (b[k] ?? -Infinity);
  return {
    title,
    children: [
      { title: "本期", dataIndex: key, key, align: "right", width, sorter: sorter(key), render: cell },
      {
        title: "上期", dataIndex: prevKey, key: prevKey, align: "right", width,
        sorter: sorter(prevKey),
        render: (v) => <span style={{ color: "#999" }}>{cell(v)}</span>,
      },
    ],
  };
};

/**
 * 下鑽第二張表的欄位。表頭與第一欄由後端的 breakdown_key 決定 ——
 * 入住日模式是房型組成、進單模式是入住日分布,其餘三欄相同。
 */
export const breakdownColumns = (detail) => {
  const key = (detail && detail.breakdown_key) || "room_cod";
  const head = key === "dat" ? "入住日" : "房型";
  return [
    { title: head, dataIndex: key, key, width: 140 },
    { title: "房晚", dataIndex: "nights", key: "nights", align: "right", width: 100, sorter: (a, b) => a.nights - b.nights },
    { title: "營收", dataIndex: "rev", key: "rev", align: "right", width: 130, render: (v) => <Money value={v} />, sorter: (a, b) => a.rev - b.rev },
    { title: "ADR", dataIndex: "adr", key: "adr", align: "right", width: 110, render: (v) => <Money value={v} /> },
  ];
};
